import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@shared/shared.module';
import { ErrorComponent } from './components/error/error.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { OfferErrorComponent } from './components/offer-error/offer-error.component';
import { OfferNotFoundComponent } from './components/offer-not-found/offer-not-found.component';
import { UnauthorisedComponent } from './components/unauthorised/unauthorised.component';
import { CoreEffects } from './store/effects/index';
import { CORE_FEATURE, coreReducers } from './store/reducers/index';

@NgModule({
  declarations: [
    ErrorComponent,
    OfferErrorComponent,
    UnauthorisedComponent,
    NotFoundComponent,
    OfferNotFoundComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(CORE_FEATURE, coreReducers),
    EffectsModule.forFeature(CoreEffects),
    SharedModule,
    DgxQmModule.forRoot(),
    DgxComponentsButtonModule,
    IconComponent,
  ],
})
export class CoreModule {}
